import { useNavigate } from "react-router-dom";

import { CommunicationListLayout } from "pages/communication/components/CommunicationListLayout";
import { useCommunicationListPage } from "pages/communication/hooks/useCommunicationListPage";
import {
  getSuggestionStatusBadgeType,
  isSuggestionDone,
} from "pages/communication/model/suggestionStatusMapper";
import {
  createSuggestionFilter,
  defaultStatusOptions,
} from "pages/communication/utils/communicationFilters";
import { createCommunicationColumns } from "pages/communication/utils/createCommunicationColumns";

function SuggestionManager() {
  const navigate = useNavigate();
  const moveToSuggestionDetail = (id) => {
    navigate(`/communication/suggestion/${id}`);
  };

  const {
    page,
    setPage,
    filteredItems,
    visibleItems,
    newPostsCount,
    itemsPerPage,
    handleSearchFilters,
    handleReset,
  } = useCommunicationListPage({
    fetchPath: "suggests",
    filterFn: createSuggestionFilter(),
  });

  const columns = createCommunicationColumns({
    titleHeader: "건의 제목",
    titleMaxLength: 12,
    writerAccessor: "writer",
    answererAccessor: "ansUser",
    getStatusType: getSuggestionStatusBadgeType,
    isDone: isSuggestionDone,
    getAnswerTime: (row) => row.ansTime,
    onDetailClick: moveToSuggestionDetail,
  });

  return (
    <CommunicationListLayout
      pageTitle="소통 - 건의관리"
      columns={columns}
      data={visibleItems}
      onRowClick={(row) => moveToSuggestionDetail(row.id)}
      searchConfig={{
        dropdownOptions: ["제목만", "답변자"],
        statusOptions: defaultStatusOptions,
        defaultSelectedOption: "제목만",
        defaultSelectedStatus: "전체",
      }}
      onSearchFilters={handleSearchFilters}
      onReset={handleReset}
      newPostsCount={newPostsCount}
      totalCount={filteredItems.length}
      page={page}
      setPage={setPage}
      itemsPerPage={itemsPerPage}
    />
  );
}

export default SuggestionManager;
